import React, { useState, useEffect } from "react";
import axios from "axios";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import styles from "./AltText.module.css";
import moment from "moment";

const AltText = (props) => {
    const [altTexts, setAltTexts] = useState([]);
    const [errorAlt, setErrorAlt] = useState(null);
    const [newAltText, setNewAltText] = useState({
        name: "",
        dates: [
            {
                startDate: moment().format("Y-MM-DD"),
                endDate: moment().add(1, "d").format("Y-MM-DD"),
            },
        ],
        text: "",
    });

    useEffect(() => {
        fetchAltTexts();
    }, []);

    const fetchAltTexts = async () => {
        try {
            const response = await axios.get(
                `/manager/data/hotels/${props.hotelId}/alt_texts`,
            );

            if (response.data?.length > 0) {
                const altTextsWithParsedDates = response.data.map((altText) => {
                    return {
                        ...altText,
                        dates: JSON.parse(altText.dates),
                    };
                });

                setAltTexts(altTextsWithParsedDates);
            }
        } catch (e) {
            console.error(e);
        }
    };

    const handleInputChange = (field, value, index) => {
        const updatedAltTexts = [...altTexts];
        updatedAltTexts[index] = { ...updatedAltTexts[index], [field]: value };
        setAltTexts(updatedAltTexts);
    };

    const handleDateArrayChange = (field, value, dateIndex, altTextIndex) => {
        const updatedAltTexts = [...altTexts];
        const isValidDate = moment(value, "YYYY-MM-DD", true).isValid();

        if (isValidDate) {
            updatedAltTexts[dateIndex].dates[altTextIndex][field] = value;
            setAltTexts(updatedAltTexts);
        }
    };

    const handleAddAltText = () => {
        setAltTexts((prevAltTexts) => [...prevAltTexts, { ...newAltText }]);
        setNewAltText({
            name: "",
            dates: [
                {
                    startDate: moment().format("Y-MM-DD"),
                    endDate: moment().add(1, "d").format("Y-MM-DD"),
                },
            ],
            text: "",
        });
    };

    const handleDeleteAltText = async (altText, index) => {
        try {
            if (altText?.id) {
                await axios.delete(
                    `/manager/data/hotels/${props.hotelId}/alt_texts/${altText.id}`,
                );
            }

            const updatedAltTexts = [...altTexts];
            updatedAltTexts.splice(index, 1);
            setAltTexts(updatedAltTexts);
        } catch (e) {
            console.error(e);
        }
    };

    const handleAddDateRange = (index) => {
        const updatedAltTexts = [...altTexts];
        updatedAltTexts[index].dates.push({
            startDate: moment().format("Y-MM-DD"),
            endDate: moment().add(1, "d").format("Y-MM-DD"),
        });
        setAltTexts(updatedAltTexts);
    };

    const handleDeleteDateRange = (index, datesIndex) => {
        if (datesIndex !== 0) {
            const updatedAltTexts = [...altTexts];
            updatedAltTexts[index].dates.splice(datesIndex, 1);
            setAltTexts(updatedAltTexts);
        }
    };

    const handleSaveAltTexts = async () => {
        try {
            const responce = await axios.post(
                `/manager/data/hotels/${props.hotelId}/alt_texts`,
                { altTexts },
            );
            if (responce.data?.success) {
                alert(responce.data.message);
            } else {
                setErrorAlt(responce.data);
                alert("Заполнены не все поля");
            }
        } catch (e) {
            console.error(e);
        }
    };

    const isSaveDisabled = altTexts.length === 0;

    return (
        <div>
            <h3 className={styles.alt__page}>
                Альтернативный текст отсутствующих предложений
            </h3>
            <div className={styles.text__container}>
                {altTexts?.map((altText, index) => (
                    <div key={index} className={styles.text__item}>
                        <TextField
                            label="Имя"
                            value={altText.name || ""}
                            onChange={(e) =>
                                handleInputChange("name", e.target.value, index)
                            }
                            error={!!errorAlt?.[`${index}.name`]}
                            helperText={errorAlt?.[`${index}.name`] || ""}
                        />
                        <br />
                        <div className={styles.dates__container}>
                            {altText?.dates.map((date, datesIndex) => (
                                <div
                                    className={styles.dates__item}
                                    key={datesIndex}
                                >
                                    {date.startDate && date.endDate && (
                                        <>
                                            <TextField
                                                className={styles.date__field}
                                                label="дата начала"
                                                type="date"
                                                value={
                                                    date.startDate ||
                                                    moment().format("Y-m-d")
                                                }
                                                onChange={(e) =>
                                                    handleDateArrayChange(
                                                        "startDate",
                                                        e.target.value,
                                                        index,
                                                        datesIndex,
                                                    )
                                                }
                                            />
                                            <TextField
                                                className={
                                                    styles.date__field__right
                                                }
                                                label="дата окончания"
                                                type="date"
                                                value={
                                                    date.endDate ||
                                                    moment().format("Y-m-d")
                                                }
                                                onChange={(e) =>
                                                    handleDateArrayChange(
                                                        "endDate",
                                                        e.target.value,
                                                        index,
                                                        datesIndex,
                                                    )
                                                }
                                            />
                                            {datesIndex !== 0 && (
                                                <IconButton
                                                    onClick={() =>
                                                        handleDeleteDateRange(
                                                            index,
                                                            datesIndex,
                                                        )
                                                    }
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            )}
                                        </>
                                    )}
                                </div>
                            ))}
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => handleAddDateRange(index)}
                            >
                                Добавить промежуток
                            </Button>
                        </div>
                        <br />
                        <TextField
                            className={styles.alt__text}
                            label="Текст"
                            multiline
                            minRows={5}
                            value={altText.text || ""}
                            onChange={(e) =>
                                handleInputChange("text", e.target.value, index)
                            }
                            error={!!errorAlt?.[`${index}.text`]}
                            helperText={errorAlt?.[`${index}.text`] || ""}
                        />
                        <br />
                        <IconButton
                            className={styles.alt__buttons}
                            onClick={() => handleDeleteAltText(altText, index)}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </div>
                ))}
            </div>
            <Button
                style={{ margin: "20px" }}
                variant="contained"
                color="primary"
                onClick={handleAddAltText}
            >
                Добавить
            </Button>
            <Button
                style={{ margin: "20px" }}
                variant="contained"
                color="secondary"
                onClick={handleSaveAltTexts}
                disabled={isSaveDisabled}
            >
                Сохранить
            </Button>
        </div>
    );
};

export default AltText;
